<template>
    <div>
        <el-dialog title="发布资源需求" :visible.sync="$store.state.demandDialogState" width="700px" :before-close="beforeClose">
            <el-form :model="demandForm"  label-width="80px" ref="demandFormRef" :rules="rules">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="需求标题" prop="requireTitle">
                            <el-input class="handle-input" v-model="demandForm.requireTitle" clearable placeholder="请输入需求标题"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="需求标签" prop="requireLabel">
                            <el-input class="handle-input" v-model="demandForm.requireLabel" clearable placeholder="请输入需求标签"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="联系人" prop="linkName">
                            <el-input class="handle-input" v-model="demandForm.linkName" clearable placeholder="请输入联系人姓名"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="联系电话" prop="linkPhone">
                            <el-input class="handle-input" v-model="demandForm.linkPhone" clearable placeholder="请输入联系电话"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="资源预算" prop="budget">
                            <el-input class="handle-input" v-model="demandForm.budget" clearable placeholder="请输入资源预算"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="需求描述" prop="requireDesc">
                    <el-input type="textarea" v-model="demandForm.requireDesc" clearable placeholder="请输入资源需求描述"></el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input type="textarea" v-model="demandForm.remark" clearable placeholder="请输入备注"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="beforeClose">取 消</el-button>
                <el-button type="primary" @click="getSubmitData">提 交</el-button>
            </div>
        </el-dialog>
    </div>

</template>

<script>
import {
    releaseDemand
} from '@/api/index.js'
export default {
    watch: {
        '$store.state.demandDialogState': function (newVal) {
            console.log(newVal);
        },
    },
    data(){
        return{
            demandForm:{
                requireTitle:"",//资源需求标题
                requireLabel:"",//资源需求标签
                linkName:"",//联系人
                linkPhone:"",//联系电话
                budget:"",//资源预算
                requireDesc:"",//资源需求描述
                remark:"",//备注
            },
            rules:{
                requireTitle: [{ required: true, message: '请输入需求标题', trigger: 'blur' }],
                requireLabel: [{ required: true, message: '请输入需求标签', trigger: 'blur' }],
                linkName: [{ required: true, message: '请输入联系人姓名', trigger: 'blur' }],
                linkPhone: [
                    { required: true, message: '请输入联系电话', trigger: 'blur' },
                    //联系电话 的 正则验证
                    { pattern: /^1[3456789]\d{9}$/, message: '联系电话格式错误,请重新输入', trigger: 'blur' }
                ],
                budget: [{ required: true, message: '请输入资源预算', trigger: 'blur' }],
                requireDesc: [{ required: true, message: '请输入资源需求描述', trigger: 'blur' }],
            }
        }
    },
    mounted(){
    },
    methods:{
        getSubmitData(){
            this.$refs.demandFormRef.validate((valid) => {
                if (valid) {
                    this.getSubmitForm();
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        getSubmitForm(){
            let cloud_login_user_role = sessionStorage.getItem('cloud_login_user_role');//用户权限 /1个人需求 2公司需求 3资源 4渠道
            let data = {
                requireTitle:this.demandForm.requireTitle, //资源需求标题
                requireLabel:this.demandForm.requireLabel, //资源需求标签
                linkName:this.demandForm.linkName, //联系人
                linkPhone:this.demandForm.linkPhone, //联系电话
                budget:this.demandForm.budget, //资源预算
                requireDesc:this.demandForm.requireDesc, //资源需求描述
                remark:this.demandForm.remark, //备注
                userType:cloud_login_user_role, //资源需求类型 1:个人 2:企业
            }
            releaseDemand(data).then(res=>{
                if(res.data){
                    this.$message.success('需求发布成功');//提示消息
                    this.$refs.demandFormRef.resetFields();//重置表单
                    this.$store.commit('SET_DEMAND_DIALOG_STATE', false); //关闭弹窗
                }else {
                    this.$message.error(res.message);
                }
            })
        },
        beforeClose(){
            this.$refs.demandFormRef.resetFields();//重置表单
            this.$store.commit('SET_DEMAND_DIALOG_STATE', false); //关闭弹窗
        }
    }
    
}
</script>


<style scoped>

.handle-input{
    width:220px;
    margin-right:10px;
}
</style>